import React from 'react';
import { IMPACT_METRICS } from '../../data/ecoContent';

export const ImpactMatrix: React.FC = () => {
  return (
    <section
      id="benchmarks"
      className="relative py-24 sm:py-32 px-4 sm:px-6 z-10 border-t border-carbon-900/10 bg-alabaster-200/50"
    >
      <div className="max-w-7xl mx-auto space-y-12">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-xs font-mono text-chlorophyll-deep tracking-widest uppercase mb-2">
              <span className="w-2 h-2 bg-chlorophyll inline-block" />
              <span>06 // EMPIRICAL BENCHMARKS</span>
            </div>
            <h2 className="font-serif font-black text-4xl sm:text-5xl text-carbon-900 tracking-tight">
              Thermodynamic supremacy.
            </h2>
          </div>
          <p className="font-mono text-xs text-carbon-900/60 max-w-sm sm:text-right">
            AUDITED COMPARATIVE METRICS // GAIA PULSE VS. VOLUNTARY PAPER CARBON CREDITS
          </p>
        </div>

        {/* Comparison Matrix Table */}
        <div className="border border-carbon-900/15 bg-white shadow-paper overflow-hidden">
          {/* Table Header (Desktop) */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-4 border-b border-carbon-900/10 bg-alabaster-200/80 font-mono text-xs text-carbon-900/60 uppercase tracking-widest">
            <div className="col-span-4">PERFORMANCE VECTOR</div>
            <div className="col-span-3 text-carbon-900 font-bold">GAIA PULSE AUTONOMOUS</div>
            <div className="col-span-3">TRADITIONAL OFFSETS</div>
            <div className="col-span-2 text-right">ADVANTAGE</div>
          </div>

          {/* Table Body Rows */}
          <div className="divide-y divide-carbon-900/10 font-mono text-sm">
            {IMPACT_METRICS.map((row, idx) => (
              <div
                key={idx}
                className="grid grid-cols-1 md:grid-cols-12 gap-4 px-6 py-6 hover:bg-alabaster-100/80 transition-colors items-center"
              >
                {/* Metric Name & Highlight */}
                <div className="md:col-span-4 space-y-1">
                  <div className="text-[10px] text-chlorophyll-deep tracking-widest uppercase font-mono">
                    [{row.category}]
                  </div>
                  <div className="font-serif font-bold text-base text-carbon-900">
                    {row.title}
                  </div>
                  <p className="text-xs font-sans text-carbon-900/60 max-w-sm">
                    {row.highlight}
                  </p>
                </div>

                {/* Gaia Pulse Value */}
                <div className="md:col-span-3 flex items-baseline gap-2">
                  <span className="text-xs text-carbon-900/40 md:hidden uppercase">GAIA:</span>
                  <span className="font-serif font-black text-2xl sm:text-3xl text-carbon-900">
                    {row.gaiaValue}
                  </span>
                  <span className="text-xs text-chlorophyll-deep font-mono">{row.unit}</span>
                </div>

                {/* Conventional Value */}
                <div className="md:col-span-3 flex items-baseline gap-2 text-carbon-900/50">
                  <span className="text-xs text-carbon-900/40 md:hidden uppercase">CONVENTIONAL:</span>
                  <span className="font-serif font-normal text-xl text-carbon-900/50 line-through">
                    {row.conventionalValue}
                  </span>
                  <span className="text-xs font-mono">{row.unit}</span>
                </div>

                {/* Advantage Delta */}
                <div className="md:col-span-2 flex items-center justify-between md:justify-end gap-2">
                  <span className="text-xs text-carbon-900/40 md:hidden uppercase">DELTA:</span>
                  <span className="inline-flex items-center gap-1 px-3 py-1 bg-chlorophyll/10 border border-chlorophyll/30 text-chlorophyll-deep font-bold text-xs tracking-wider">
                    +{row.advantagePercentage}%
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
